import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { AppNav } from "@/components/AppNav";
import { CrisisButton } from "@/components/CrisisButton";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) throw redirect({ to: "/auth" });
    return { user: data.user };
  },
  component: () => (
    <div className="min-h-screen">
      <AppNav />
      <main className="max-w-6xl mx-auto px-6 py-8">
        <Outlet />
      </main>
      <CrisisButton />
    </div>
  ),
});
